import { RETURN_DEVICE_COUNTRIES } from "@/common/constants";
import { validateRequiredString } from "@/common/helpers/form-validation.util";
import { getString } from "@/common/uistringlabels/ui-string-utils";

export { REQUIRED_FIELD_ERROR, validateRequiredString } from "@/common/helpers/form-validation.util";

export const ADDRESS_LINE_3_WITHOUT_LINE_2_ERROR = getString(
  "checkout.formPanel.shippingDetailsCard.addressLine3WithoutLine2"
);

export const validateAddressLine3 = (value: string, formValues: { addressLine2: string }) =>
  value.trim() === "" || formValues.addressLine2.trim() !== "" || ADDRESS_LINE_3_WITHOUT_LINE_2_ERROR;

const COST_CENTER_PATTERN = /^\d{4,5}$/;

export const validateCostCenter = (value: string) => {
  const requiredResult = validateRequiredString(value);
  if (requiredResult !== true) {
    return requiredResult;
  }
  return COST_CENTER_PATTERN.test(value.trim()) || getString("checkout.formPanel.managerCard.costCenterFormatError");
};

export const isDeviceReturnRequired = (homeCountry: string) =>
  RETURN_DEVICE_COUNTRIES.includes(homeCountry);
